import { useQuery } from 'react-query';
import LoadingSpinner from '@/components/LoadingSpinner';
import { apiClient } from '@/api/client';
import { formatNumber } from '@/utils/formatters';

const UsagePage = () => {
  const { data: stats, isLoading } = useQuery('usage', () => apiClient.getUsageStats());

  if (isLoading) {
    return <LoadingSpinner size="lg" />;
  }

  if (!stats) {
    return <div className="card">No usage data available</div>;
  }

  const usagePercentage = stats.monthly_limit
    ? (stats.characters_used_this_month / stats.monthly_limit) * 100
    : 0;

  return (
    <div>
      <div className="title-one mb-2">
        <h2>Usage Statistics</h2>
      </div>
      <p className="text-dark mb-40">Monitor your API usage and limits</p>

      <div className="row gx-xl-4 mb-40">
        <div className="col-md-6 col-lg-3">
          <div className="card-style-one border-30 bg-white text-center">
            <p className="text-dark mb-2">Characters This Month</p>
            <div className="main-count fw-500 color-dark">
              {formatNumber(stats.characters_used_this_month)}
            </div>
            {stats.monthly_limit && (
              <p className="text-dark mt-2">
              of {formatNumber(stats.monthly_limit)} limit
            </p>
            )}
          </div>
        </div>

        <div className="col-md-6 col-lg-3">
          <div className="card-style-one border-30 bg-white text-center">
            <p className="text-dark mb-2">Requests This Month</p>
            <div className="main-count fw-500 color-dark">
              {formatNumber(stats.requests_this_month)}
            </div>
          </div>
        </div>

        <div className="col-md-6 col-lg-3">
          <div className="card-style-one border-30 bg-white text-center">
            <p className="text-dark mb-2">Total Requests</p>
            <div className="main-count fw-500 color-dark">
              {formatNumber(stats.total_requests)}
            </div>
          </div>
        </div>

        <div className="col-md-6 col-lg-3">
          <div className="card-style-one border-30 bg-white text-center">
            <p className="text-dark mb-2">Total Characters</p>
            <div className="main-count fw-500 color-dark">
              {formatNumber(stats.total_characters)}
            </div>
          </div>
        </div>
      </div>

      {stats.monthly_limit && (
        <div className="card-style-one border-30 bg-white">
          <div className="d-flex justify-content-between align-items-center mb-2">
            <p className="text-dark fw-500">Monthly Quota</p>
            <p className="text-dark">
              {usagePercentage.toFixed(1)}% used
            </p>
          </div>
          <div className="progress" style={{ height: '10px' }}>
            <div
              className="progress-bar bg-primary"
              role="progressbar"
              style={{ width: `${Math.min(usagePercentage, 100)}%` }}
            ></div>
          </div>
        </div>
      )}
    </div>
  );
};

export default UsagePage;

